<ng-container *ngIf="isMobileView">

    <!-- *ngIf="media.isActive('lt-md')" -->
    <mat-toolbar class="header-bar-sidenav-toolbar"
                 fxLayoutAlign="space-between center"
                 fxLayoutAlign.lt-md="start center">
        <button mat-stroked-button
                class="sidenav-toggle"
                aria-labelledby="navigation"
                (click)="onMenuButtonClick($event)"
                *ngIf="!hideMobileMenuButton">
            <mat-icon role="img"
                      class="sidenav-menu-icon mat-icon notranslate material-icons mat-icon-no-color"
                      aria-hidden="true"
                      data-mat-icon-type="font">menu</mat-icon>
        </button>
        <div *ngIf="hideMobileMenuButton && (assetDetailsFacade.getIsAssetSelected() | async) === false">
            <span icon class="glyphs" (click)="handleSettingsDialog()">J</span>
        </div>
        <ng-container *ngIf="title">
            {{title}}
        </ng-container>
        <ng-content>
        </ng-content>
    </mat-toolbar>
</ng-container>